import { useCallback } from 'react';
import hive from '@bombas/hive';
import { useRouter } from 'next/router';
import { useApolloClient } from '@apollo/client';
import PubSub from 'pubsub-js';
import { addToCart } from '../services/storefront/cart';

const useGiftCardSend = (product, currentVariant) => {
  const router = useRouter();
  const client = useApolloClient();
  const isGiftCard = currentVariant?.sku?.includes('GIFTCARD');

  const getPropertiesForV1 = useCallback((gift) => {
    const { name, email, message, send_at } = gift;
    return {
      'Recipient name': name,
      'Recipient email': email,
      ...(message ? { Message: message } : {}),
      'Send on': send_at,
      __shopify_send_gift_card_to_recipient: true
    };
  }, []);

  const handleGiftCardAdded = useCallback(
    async ({ gift, isQuickView, setActiveProductId, previousUrl }) => {
      try {
        const productId = currentVariant.externalSystems?.shopify;
        const productToBeAdded = {
          id: productId,
          properties: getPropertiesForV1(gift)
        };
        await addToCart(
          productToBeAdded.id,
          1,
          {
            category: product.categories,
            isPack: false,
            packSize: 1
          },
          Object.entries(productToBeAdded.properties).map(([key, value]) => ({
            key,
            value: String(value)
          })),
          client,
          product.externalSystems?.shopify
        );
      } finally {
        if (!isQuickView) {
          hive.track('CART_ADD_PDP');
        } else {
          hive.track('CART_ADD_PCP');
        }

        PubSub.publish('cart.open');

        // Closes QuickView modal when a product is added to cart from the QuickView modal
        // After that, we update the URL back to the PCP and remove the added history from the stack
        if (isQuickView) {
          hive.track('CART_ADD_QUICKVIEW');

          setActiveProductId(null);
          setTimeout(() => {
            router.replace(previousUrl, '', {
              scroll: false,
              shallow: true
            });
            router.back();
          }, 400);
        }
      }
    },
    [currentVariant, product, client, getPropertiesForV1]
  );

  return { isGiftCard, handleGiftCardAdded };
};

export default useGiftCardSend;
